angular.module('bribac.views.listAlerts', [
  'bribac.translations',
  'bribac.entities.kinds',
  'bribac.services.routeAuth',
  'bribac.services.api',
  'bribac.components.whenLoaded',
  'ui.bootstrap',
  'bribac.translations'
])

  .config(function(
    $routeProvider
  ) {
    $routeProvider.when('/alerts', {
      templateUrl: 'list-alerts-view.html',
      controller: 'ListAlertsViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: function(routeAuth) {return routeAuth.requireAuth()}}
    })
  })

  .controller('ListAlertsViewCtrl', function(
    $scope,
    $filter,
    $translate,
    KINDS,
    api,
    permissions
  ) {
    var $ctrl = this;

    $ctrl.permissions = permissions
    $ctrl.filter = 'all';
    $ctrl.filterToPrint = $translate.instant('views.listAlerts.noAll', null, "", "", "");
    $ctrl.typeFilter = getOptionForInstantId('violation.test_failed');
    $ctrl.currentPage = 1;
    $ctrl.pageSize = 10;
    $ctrl.total = 0;
    $ctrl.organization = {id: -1, name: ''}

    // sort related
    $ctrl.sortBy = 'dateCreated';
    $scope.reverse = true;

    // filter related
    $ctrl.filteredData = [];
    $ctrl.chosenDateFrom = null;
    $ctrl.chosenDateTo = null;
    $ctrl.datePickerOpen = {
      startDate: false,
      endDate: false
    }

    function getOptionForInstantId(instantId) {
      return {
        name: $translate.instant(instantId, null, "", "", ""),
        id: instantId,
        filterName: getFilterName(instantId)
      };
    }

    function getFilterName(instantId) {
      switch (instantId) {
        case 'violation.test_failed':
          return 'FAILED_TEST'
        case 'violation.optional_sample':
          return 'FAILED_OPTIONAL'
        case 'violation.test_expired':
          return 'EXPIRED_TEST'
        case 'alert.ibac_calibration':
          return 'IBAC_CALIBRATION_NEEDED'
        case 'alert.ibac_battery':
          return 'IBAC_LOW_BATTERY'
        case 'alert.ibac_tampered':
          return 'IBAC_TAMPERED'
        case 'alert.face_recognition':
          return 'FRS_FAILED'
        default:
            return 'FAILED_TEST'
      }
    }

    $ctrl.alertTypes = [
      getOptionForInstantId("alert.ibac_calibration"),
      getOptionForInstantId("alert.ibac_battery"),
      getOptionForInstantId("alert.ibac_tampered"),
      getOptionForInstantId("alert.face_recognition")
    ];

    $ctrl.violationTypes = [
      getOptionForInstantId("violation.test_expired"),
      getOptionForInstantId("violation.test_failed"),
      getOptionForInstantId("violation.optional_sample")
    ];

    $ctrl.typesSelectionOptions = $ctrl.alertTypes.concat($ctrl.violationTypes);

    $ctrl.numOfPages = function () {
      return Math.ceil($ctrl.total / $scope.pageSize);
    };

    $ctrl.toggleDatePicker = function(picker) {
      $ctrl.datePickerOpen[picker] = !$ctrl.datePickerOpen[picker]
    }

    function filterData() {
      switch ($ctrl.filter) {
        case 'alerts':
          $ctrl.filterToPrint = $translate.instant('alertFilter.alerts', null, "", "", "");
          $ctrl.preFilteredData = $ctrl.alerts;
          $ctrl.typesSelectionOptions = $ctrl.alertTypes;
          break;
        case 'violations':
          $ctrl.filterToPrint = $translate.instant('alertFilter.violations', null, "", "", "");
          $ctrl.preFilteredData = $ctrl.violations;
          $ctrl.typesSelectionOptions = $ctrl.violationTypes;
          break;
        case 'all':
          $ctrl.filterToPrint = $translate.instant('views.listAlerts.noAll', null, "", "", "");
          $ctrl.preFilteredData = $ctrl.all;
          $ctrl.typesSelectionOptions = $ctrl.alertTypes.concat($ctrl.violationTypes);
          break
      }

      $ctrl.filteredData = $ctrl.preFilteredData;
    }

    $scope.$watch('$ctrl.organization', orgChanged)

    function orgChanged(){
      $ctrl.sendRequest(true)
    }

    $ctrl.sendRequest = function (pageReset) {
      if(pageReset)
        $ctrl.currentPage = 1

      api.getAlertsView($ctrl.typeFilter.filterName,
          ($ctrl.currentPage - 1) * $ctrl.pageSize,
          $ctrl.pageSize,
          $ctrl.chosenDateFrom ? moment($ctrl.chosenDateFrom).format('YYYY-MM-DD') : null,
          $ctrl.chosenDateTo ? moment($ctrl.chosenDateTo).format('YYYY-MM-DD') : null,
          $ctrl.subject,
          $ctrl.subGroup,
          $ctrl.mainGroup,
          $ctrl.ibac,
          $ctrl.organization.id === -1 ? null: $ctrl.organization.id,
          $ctrl.sortBy,
          $scope.reverse? "DESC" : "ASC"
          ).then(function (request) {
        $ctrl.alerts = request.data.alerts
        $ctrl.violations = request.data.violations
        $ctrl.all = request.data.alerts.concat(request.data.violations)
        $ctrl.total = request.data.count
        $scope.$watch('$ctrl.filter', filterData)
      })
    }

    $ctrl.changeSort = function (column) {
      $ctrl.sortBy = column
      $scope.reverse = !$scope.reverse
      $ctrl.sendRequest(true)
    };

    $ctrl.calculateCurrentPageResults = function() {
      return $ctrl.filteredData;
    };


    $ctrl.cleanDateFrom = function () {
      $ctrl.chosenDateFrom = null;
      $ctrl.sendRequest(true)
    };

    $ctrl.cleanDateTo = function () {
      $ctrl.chosenDateTo = null;
      $ctrl.sendRequest(true);
    };
  });